// extracted by mini-css-extract-plugin
export default {"team_feedback":"S1_TeamFeedback_team_feedback__GMtk0","description":"S1_TeamFeedback_description__SR8Bu","name_designation":"S1_TeamFeedback_name_designation__DF+in"};